import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App.js'
import { SessionExpiredError } from './lib/api.js'
import './index.css'

/** A rejected refresh anywhere sends the app back to the login. */
const onError = (error: unknown): void => {
  if (error instanceof SessionExpiredError) window.dispatchEvent(new Event('hub:session-expired'))
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError }),
  mutationCache: new MutationCache({ onError }),
  defaultOptions: {
    queries: {
      retry: (count, error) => !(error instanceof SessionExpiredError) && count < 1,
      staleTime: 15_000,
      // Claude may have changed the plan meanwhile: coming back to the app shows the current state.
      refetchOnWindowFocus: true,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
